export default __webpack_public_path__ + "static/assets/5a55bec880b03943793e75cc6f898404.svg";